import React ,{useContext} from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { AuthContext } from 'context/AuthProvider';
import TextLink from 'components/UI/TextLink/TextLink';
import Favourite from 'components/UI/Favorite/Favorite';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import GridCard from '../GridCard/GridCard';
import Review from 'containers/SinglePage/Review/Review';
import { SharedDataContext } from 'context/SharedDataProvider';

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024,
    },
    items: 1,
    paritialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0,
    },
    items: 1,
    paritialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464,
    },
    items: 1,
    paritialVisibilityGutter: 30,
  },
};

const PostGrid = ({
  nom,
  adresse,
  price,
  images,
  id,
  prixMinimumEuro,
  prixMinimumAriary,
  prixDayUseMinAriary,
  prixDayUseMinEuro,
  link,
  currency,
  favoris,
  linkClicked,
  slug
}) => {

  const {user} = useContext(AuthContext);
  const { isFiltreDayUseChecked } = useContext(SharedDataContext);
  
  let isClient = false ; 
  let token = null ; 
  if (user?.roles && user.roles.includes('ROLE_CLIENT')){
    isClient = true ; 
    token = user.token ; 
  }

  let prix = 0;

  if (isFiltreDayUseChecked) {
    prix = currency == "€" ? prixDayUseMinEuro: prixDayUseMinAriary;
  }else {
    prix = currency == "€" ? prixMinimumEuro: prixMinimumAriary;
  }

  return (
    <GridCard
      isCarousel={true}
      currency={currency}
      favorite={
        <Favourite 
          isFavorite={favoris}
          onClick={(event) => {
            if(event){
              fetch(`${process.env.REACT_APP_API_URL}/hotels/add/favori/${id}`, {
                "method": "POST",
                headers : {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${user?.token}`
                }
              }).then(
                (res) => {
                })
                .catch(err => {
                });
            }
            else if (!event){
              fetch(`${process.env.REACT_APP_API_URL}/hotels/remove/favori/${id}`, {
                "method": "POST",
                headers : {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${user?.token}`
                }
              }).then(
                (res) => {
                })
                .catch(err => {
                });
            }
          }}
        />
      }
      location={adresse}
      title={<TextLink link={`${link}/${id}/${slug}`} content={nom} style={{ color: '#2C2C2C' }}/>}
      price={prix}//{<MoneyFormat value={`${prix}`} suffix={` ${currency}`}/>}
      displayReview={
        <Review
            displayAddBtn={false}
            displayDetail={false}
            idHotel={id}
          />
      }
      viewDetailsBtn={
        <TextLink
          link={`${link}/${id}/${slug}`}
          icon={<FiExternalLink />}
          style={{ color: 'rgb(40 ,177, 89)' }}
          content="Détails"
          linkClicked={linkClicked}
        />
      }
      isClient={isClient}
    >
      <Carousel
        additionalTransfrom={0}
        arrows
        autoPlaySpeed={3000}
        containerClass="container"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        renderDotsOutside={false}
        responsive={responsive}
        showDots={true}
        sliderClass=""
        slidesToSlide={1}
      >
        {images?.map(({ url, name }, index) => (
          <img
            src= {`${process.env.REACT_APP_API_URL}/${url}`}
            alt={name}
            key={index}
            draggable={false}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'relative',
            }}
          />
        ))}
      </Carousel>
    </GridCard>
  );
};

export default PostGrid;
